import Vue from 'vue'
import iView from 'view-design'
import 'view-design/dist/styles/iview.css'
import App from './app.vue'
import util from './libs/util'
import router from './router/router'
import store from './store/store'
import VueI18n from 'vue-i18n'
import localeI18n from './i18n/index'
import ButtonLimited from './views/component/button-limited'
import byStore from 'biyi-store'
import {Tree, Cascader, Image, Transfer, Popover, Button, Pagination } from 'element-ui'
import dayjs from 'dayjs';
import common from '@/libs/common.js';
import 'video.js/dist/video-js.min.css'
import 'videojs-contrib-hls'

import './css/font.css'
import './css/index.less'
Vue.config.productionTip = false
Vue.prototype.$util = util
Vue.prototype.$http = util.http
Vue.prototype.dayjs = dayjs;
Vue.prototype.jump = common.jump;

Vue.use(VueI18n)
Vue.use(byStore)
Vue.use(Tree)
Vue.use(Cascader)
Vue.use(Image)
Vue.use(Transfer)
Vue.use(Popover)
Vue.use(Button)
Vue.use(Pagination)
Vue.use(iView, {
  i18n: function (path, options) {
    let value = i18n.t(path, options)
    if (value !== null && value !== undefined) {
      return value
    }
    return ''
  }
})

Vue.component('Button', ButtonLimited)

Vue.locale = () => {
}

const i18n = new VueI18n(localeI18n)

const vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

export default vm
